// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form {
  width: 100%;
}

.login-form__field {
  margin-bottom: 16px;
}

.login-form__actions {
  margin-top: 24px;
}

.custom-input {
  color: var(--label-login-color);
  padding-left: 10px !important;
  height: 3rem;
  margin: auto;
  display: inline-block;
  border-radius: 5px;
}

.btn-default {
  height: 3rem;
  width: 100%;
  max-width: none;
  font-family: "Roobert-Bold";
}

.btn-default .align-loader {
  min-height: 0;
  margin: 0;
}

.input-label-text {
  color: rgba(0, 0, 0, 0.65);
  font-size: 0.8em;
  padding-left: 3px;
}

.login-title {
  color: var(--text-color-1st-login);
}`, "",{"version":3,"sources":["webpack://./src/app/components/login-with-shortcode/login-with-shortcode.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,+BAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,eAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;AACF;;AAEA;EACE,0BAAA;EACA,gBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kCAAA;AACF","sourcesContent":[".login-form {\n  width: 100%;\n}\n\n.login-form__field {\n  margin-bottom: 16px;\n}\n\n.login-form__actions {\n  margin-top: 24px;\n}\n\n.custom-input {\n  color: var(--label-login-color);\n  padding-left: 10px!important;\n  height: 3rem;\n  margin: auto;\n  display: inline-block;\n  border-radius: 5px;\n}\n\n.btn-default {\n  height: 3rem;\n  width: 100%;\n  max-width: none;\n  font-family: 'Roobert-Bold';\n}\n\n.btn-default .align-loader {\n  min-height: 0;\n  margin: 0;\n}\n\n.input-label-text {\n  color: rgba(0, 0, 0, 0.65);\n  font-size: .8em;\n  padding-left: 3px;\n}\n\n.login-title {\n  color: var(--text-color-1st-login);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
